<template>
    <div class="table">
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校" @change="common.page = 1;getData()">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;"> 
                <el-date-picker
                    v-model="form.startDate"
                    type="date"
                    placeholder="开始时间"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" style="width:150px;">
                </el-date-picker> 
                    
            </div>
            <div style="display: inline-block; height:40px;">
                <el-date-picker
                    v-model="form.endDate"
                    type="date"
                    placeholder="结束时间"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" style="width:150px;">
                </el-date-picker> 
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.evaluateTitle" placeholder="评价指标"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.name" placeholder="评价对象"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.gradeName" placeholder="所属年级"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;" v-if="form.setGradeSign == 0">
                <div style="width:170px;">
                    <el-select v-model="form.gradeId" clearable placeholder="请选择小学或者初中">
                        <el-option
                            v-for="item in gradeList"
                            :key="item.gradeId"
                            :label="item.gradeName"
                            :value="item.gradeId">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                <el-button type="primary" icon="search" @click="exportReport()">导出</el-button>
                <el-button type="primary" v-if="purviewSwitch" icon="search" @click="exportCountReport()">导出统计报表</el-button>
            </div>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="success" @click="queryDate(5)" v-if="form.dateType == 5">最近30天 </el-button>
                <el-button type="success" plain @click="queryDate(5)" v-if="form.dateType != 5">最近30天 </el-button>
                <el-button type="success" plain @click="queryDate(4)">最近7天</el-button>
                <el-button type="success" plain @click="queryDate(3)">昨天</el-button>
                <el-button type="success" plain @click="queryDate(2)">今天</el-button>
                <el-button type="success" plain @click="queryDate(6)">本周</el-button>
                <el-button type="success" plain @click="queryDate(7)">上周</el-button>
                <el-button type="success" plain @click="queryDate(1)">本月</el-button>
                <el-button type="success" plain @click="queryDate(0)">上月</el-button>
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                border
                default-expand-all>
                <el-table-column type="index"  label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="" label="编号"  :show-overflow-tooltip="true" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.serialNo !=null && scope.row.serialNo !='' ">
                            {{scope.row.serialNo}}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="evaluateModule"  label="评价模块">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateModule == 1">
                            学生评价
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 2">
                            课堂评价
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 3">
                            班级评价/
                            <span v-if="scope.row.commonName != null">
                                {{scope.row.commonName}}/
                            </span>
                            {{scope.row.classEvaluateIndicatorsName}}
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 4">
                            实践评价
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 5">
                            教职评价/
                            <span v-if="scope.row.commonName != null">
                                {{scope.row.commonName}}/
                            </span>
                            {{scope.row.classEvaluateIndicatorsName}}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评价对象" width="80">
                    <template slot-scope="scope">
                        <!--评价目标（1-班级，2,3-姓名）-->
                        <div v-if="scope.row.evaluateTarget == 1">
                            班级
                        </div>
                        <div v-else>
                            {{scope.row.name}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评价类型"  :show-overflow-tooltip="true" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateType == 1">
                            表扬
                        </div>
                        <div v-else-if="scope.row.evaluateType == 2">
                            待改进
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评价指标"  :show-overflow-tooltip="true" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateType == 3">
                            无
                        </div>
                        <div v-else>
                            {{scope.row.evaluateTitle}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评价分值">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateType == 1">
                            +{{scope.row.evaluateScore}}
                        </div>
                        <div v-else-if="scope.row.evaluateType == 2">
                            <span style="color: red;">{{scope.row.evaluateScore}}</span>
                        </div>
                        <div v-else>
                            {{scope.row.evaluateScore}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="gradeName" label="所属年级" width="100"></el-table-column>
                <el-table-column prop="evaluateTime" label="评价时间"   width="100"></el-table-column>
                <el-table-column prop="createName" label="评价人"  width="80"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 导出配置弹出框 -->
        <div v-if="teacherEvaluateExprotVisible">
            <teacherEvaluateExprot ref="teacherEvaluateExprot"></teacherEvaluateExprot>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http'; 
    import teacherEvaluateExprot from './TeacherEvaluateExprot.vue';

    export default {
        name:"",
        data(){
            return{
                loading:false,
                loadingText:"",
                teacherEvaluateExprotVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    deptId:"",
                    startDate:"",
                    endDate:"",
                    evaluateTitle:"",
                    name:"",
                    gradeName:"",
                    gradeId:"",
                    dateType:5,
                    setGradeSign:"" // 年级 小学（1-6），初中（7-9） 是否存在（-1-不存在，0-存在）
                },
                data: [],
                depts: [],
                gradeList: [],
                purviewSwitch: undefined
            }
        },
        components: {
            teacherEvaluateExprot
        },
        created:function () {
            this.getDeptData()
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1)
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id
                        }
                        // 最近30天
                        this.queryDate(5)
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                });
            },
            getData(){
                if(this.form.startDate == null){
                    this.$commonFn.showTip('开始时间不可为空',3)
                    return
                }

                if(this.form.endDate == null){
                    this.$commonFn.showTip('结束时间不可为空',3)
                    return
                }

                this.loading=true
                this.loadingText="正在加载中..."

                let url  = this.evaluateDetailListUrl;
                let data = { 
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    evaluateTitle:this.form.evaluateTitle,
                    name:this.form.name,
                    gradeName:this.form.gradeName,
                    queryGradeId:this.form.gradeId,
                    evaluateTarget:3, // 评价目标（1-班级，2-学生，3-教职）
                    evaluateModule:5, // 评价模块（1-学生评价，2-课堂评价，3-班级评价，4-实际作业，5-教职评价）
                    startDate:(this.form.startDate == null?"":this.form.startDate),
                    endDate:(this.form.endDate == null?"":this.form.endDate)
                };
                // console.log("请求参数："+JSON.stringify(data));
                this.apiPost(url,data).then((res) => {
                    // console.log(res.data);
                    if(res.status==200){
                        this.data = res.data.list
                        this.common.total=res.data.total
                        this.form.setGradeSign = res.data.setGradeSign
                        this.gradeList = res.data.gradeList
                        this.purviewSwitch = res.data.purviewSwitch
                    }else{
                        this.$commonFn.showTip(res.message,3)
                        this.form.setGradeSign = -1
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val
                this.common.page = 1
                this.getData()
            },
            handleCurrentChange(val) {
                this.common.page = val
                this.getData()
            },
            // 获取日期
            queryDate(dateType){
                // this.$forceUpdate();
                this.form.dateType=dateType
                let url  = this.honorSetQueryDateUrl
                let data = {
                    dateType:this.form.dateType //dateType:0-上月，1-本月，2-今天，3-昨天，4-最近7天，5-最近30天
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.form.startDate=res.data.startDate
                       this.form.endDate=res.data.endDate
                       // 查询数据
                       this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                });
            },
            // 导出报表统计
            exportCountReport(data){
                if(this.form.startDate == null){
                    this.$commonFn.showTip('开始时间不可为空',3)
                    return
                }

                if(this.form.endDate == null){
                    this.$commonFn.showTip('结束时间不可为空',3)
                    return
                }
                this.teacherEvaluateExprotVisible = true
                this.$nextTick(() => {
                    this.$refs['teacherEvaluateExprot'].init(this.form)
                })
           },
           // 导出报表
           exportReport(data){
                if(this.form.startDate == null){
                    this.$commonFn.showTip('开始时间不可为空',3)
                    return
                }

                if(this.form.endDate == null){
                    this.$commonFn.showTip('结束时间不可为空',3)
                    return
                }
                this.loading=true
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待"

                let url=this.evaluateDetailTeacherExportUrl
                let param = new URLSearchParams()
                param.append('deptId', this.form.deptId)
                param.append('startDate', this.form.startDate)
                param.append('endDate', this.form.endDate)
                param.append('evaluateTarget',3)
                param.append('evaluateModule',5)
                param.append('evaluateTitle',this.form.evaluateTitle)
                param.append('name',this.form.name)
                param.append('gradeName',this.form.gradeName)
                param.append('queryGradeId',this.form.gradeId)
                
                let reg=new RegExp('-','g')
                let startDate=this.form.startDate.replace(reg,'.')
                let endDate=this.form.endDate.replace(reg,'.')
                let fileName="教职评价"+"("+startDate+"-"+endDate+")"

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a")
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob)
                    link.setAttribute("download", fileName+'.xls')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    this.loading=false
                }).catch(error => {
                    console.log(error)
                    this.loading=false
                });

           },
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/TeacherEvaluateCount.vue